// Rangos y mensajes de validación numérica (PROMPT 5).
// El front valida para no hacer esperar; el backend valida porque es el que manda.
// Cada mensaje está escrito para su pregunta: nunca un "valor inválido" genérico.
export const RANGO = {
  personas: {
    min: 1,
    max: 100000,
    msg: "Ese número no me cierra. ¿Cuántas personas trabajan hoy en la empresa, contándote?",
  },
  horas: {
    min: 1,
    max: 730,
    msg: "Eso es más horas de las que tiene un mes. ¿Cuántas horas te lleva por mes?",
  },
  valorHora: {
    confirmaAlto: 500,
    confirmaBajo: 1,
    max: 100000,
    msgInvalido: "Ese número no me cierra. ¿Cuánto vale, más o menos, una hora tuya en dólares?",
  },
};

// Personas: el cliente responde con un número puro. Rangos/texto se manejan aparte (equipo/IA).
export function tamanoValido(v) {
  const s = String(v ?? "").trim();
  if (!s) return true; // vacío se maneja en cada pantalla
  if (!/^\d+$/.test(s)) return false;
  const n = parseInt(s, 10);
  return n >= RANGO.personas.min && n <= RANGO.personas.max;
}
